// eslint-disable-next-line import/no-cycle
import { getDemoAccountToken } from './token';

interface StorageOptions {
  useSessionStorage?: boolean;
}

function getStorage(useSessionStorage?: boolean) {
  if (!!getDemoAccountToken() || useSessionStorage) {
    return sessionStorage;
  }
  return localStorage;
}

export const StorageUtil = {
  setItem(key: string, value: string, opts?: StorageOptions) {
    const storage = getStorage(opts?.useSessionStorage);
    storage.setItem(key, value);
  },

  getItem(key: string, opts?: StorageOptions) {
    const storage = getStorage(opts?.useSessionStorage);
    return storage.getItem(key);
  },

  removeItem(key: string, opts?: StorageOptions) {
    const storage = getStorage(opts?.useSessionStorage);
    storage.removeItem(key);
  },
};
